// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Barre de recherche de références d'étiquette */

.search {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.searchInputs {
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.react-tagsinput {
  width: 450px;
  height: 50px;
  border-radius: 15px;
  font-family: sans-serif;
  font-size: 18px;
  background-color: black !important;
  color: white;
      padding-left: 10px !important;
  box-shadow: 0px 2px 5px grey;
  border: solid 1px white;
  margin-top: -1rem !important;
}

.react-tagsinput {
	padding-left: 0;
	margin-top: 0;
}

.react-tagsinput-tag {
    background-color: #fff !important;
    border: 1px solid #000 !important;
    color: #000 !important;
}

.react-tagsinput-input {
    font-size: inherit !important;
    width: auto !important;
}

.react-tagsinput input::placeholder {
  color: white;
}

.searchIcon svg {
  font-size: 50px;
  margin-top: -1rem;
}

#clearBtn {
  cursor: pointer;
}

.dataResult {
  width: 470px;
  max-height: 150px;
  margin-right: 30px;
  margin-left: 2px;
  background-color: black;
  border-radius: 9px;
  font-size: 18px;
  box-shadow: 0px 2px 5px grey;
  overflow: hidden;
  overflow-y: auto;
}

.dataResult:empty {
  display: none;
}

.dataResult::-webkit-scrollbar-thumb {
  background: red;
  border-radius: 15px;
}

.dataResult::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background: black;
  border-radius: 0 15px 15px 0;
}

.dataItem {
  width: 100%;
  color: white;
  font-family: sans-serif;
  font-size: 18px;
  background-color: black;
}

option.dataItem:hover {
  background-color: #1e90ff;
  cursor: pointer;
}

option.dataItem {
  padding: 0 0 0 10px;
}
@media screen and (max-width: 50em) {
  .Logo2bad-login{
	width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/SearchBar.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kCAAkC;EAClC,YAAY;MACR,6BAA6B;EACjC,4BAA4B;EAC5B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;CACC,eAAe;CACf,aAAa;AACd;;AAEA;IACI,iCAAiC;IACjC,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;CACD,WAAW;EACV;AACF","sourcesContent":["/* Barre de recherche de références d'étiquette */\n\n.search {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.searchInputs {\n  margin-top: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.react-tagsinput {\n  width: 450px;\n  height: 50px;\n  border-radius: 15px;\n  font-family: sans-serif;\n  font-size: 18px;\n  background-color: black !important;\n  color: white;\n      padding-left: 10px !important;\n  box-shadow: 0px 2px 5px grey;\n  border: solid 1px white;\n  margin-top: -1rem !important;\n}\n\n.react-tagsinput {\n\tpadding-left: 0;\n\tmargin-top: 0;\n}\n\n.react-tagsinput-tag {\n    background-color: #fff !important;\n    border: 1px solid #000 !important;\n    color: #000 !important;\n}\n\n.react-tagsinput-input {\n    font-size: inherit !important;\n    width: auto !important;\n}\n\n.react-tagsinput input::placeholder {\n  color: white;\n}\n\n.searchIcon svg {\n  font-size: 50px;\n  margin-top: -1rem;\n}\n\n#clearBtn {\n  cursor: pointer;\n}\n\n.dataResult {\n  width: 470px;\n  max-height: 150px;\n  margin-right: 30px;\n  margin-left: 2px;\n  background-color: black;\n  border-radius: 9px;\n  font-size: 18px;\n  box-shadow: 0px 2px 5px grey;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.dataResult:empty {\n  display: none;\n}\n\n.dataResult::-webkit-scrollbar-thumb {\n  background: red;\n  border-radius: 15px;\n}\n\n.dataResult::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n  background: black;\n  border-radius: 0 15px 15px 0;\n}\n\n.dataItem {\n  width: 100%;\n  color: white;\n  font-family: sans-serif;\n  font-size: 18px;\n  background-color: black;\n}\n\noption.dataItem:hover {\n  background-color: #1e90ff;\n  cursor: pointer;\n}\n\noption.dataItem {\n  padding: 0 0 0 10px;\n}\n@media screen and (max-width: 50em) {\n  .Logo2bad-login{\n\twidth: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
